module.exports = __webpack_public_path__ + "img/logo-WC-main-nav-drawer-white.de8f82b1.svg";